// Graph configuration constants
export const DEGREE_TIME_RANGE_DAYS = 84; // ~12 weeks; chart shows weekly averages
export const TOOLTIP_DELAY_MS = 75;
export const API_URL = process.env.REACT_APP_API_URL || "/api";

// Endpoint mapping
export const ENDPOINTS = { 
  Stock: "stock_data", 
  Crypto: "crypto_data", 
  Forex: "forex_data" 
};

// Color constants
export const COLORS = {
  forex: { 
    default: 'rgba(150,230,150,1)', 
    selected: 'rgba(120,220,120,1)', 
    link: 'rgba(180,240,180,0.9)' 
  },
  default: { 
    default: 'rgba(255,150,30,1)', 
    selected: 'rgba(255,90,90,1)', 
    link: 'rgba(255,200,146,0.9)' 
  }
};

// Graph visualization constants
export const GRAPH_CONFIG = {
  linkDirectionalArrowLength: 8.5,
  linkDirectionalArrowRelPos: 0.5,
  linkCurvature: 0.15,
  numDimensions: 2,
  linkHoverPrecision: 10,
  collisionRadius: 8,
  initialZoom: 1,
  initialZoomDuration: 100,
  centerAtDuration: 100
};

